import React, { useEffect, useState } from "react";
import {
  ConfigProvider,
  Modal,
  Button,
  Form,
  Input,
  Image,
  Alert,
  Row,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getAccessToken } from "../../../utils";
import { changePassword } from "../../../api/repositories";
import PasswordHide from "../../../assets/images/svgs/ic_passwordhide_changepassword.svg";
import PasswordShow from "../../../assets/images/svgs/ic_passwordshow_changepassword.svg";
import { setInvalidToken } from "../../../redux/features/main/invalidTokenSlice";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useTranslation } from "react-i18next";
import {
  borderInputChangePassword,
  borderErrorInputChangePassword,
  textInputChangePassword,
  textDescriptionChangePassword,
  textTitleChangePassword,
  colorTextTitleMobile,
  colorTextDesc,
  colorButtonLogOut,
  colorTextList,
} from "../../../config/constant/color/index";

const ChangePassword = ({
  openModalPassword,
  setModalPassword,
  setModalSuccessPassword,
}) => {
  const screens = useBreakpoint();
 const isScallingVersion =
  window.innerWidth < 992 && (window.innerHeight >= window.innerWidth || window.innerWidth > window.innerHeight);
  const isMobileVersion = screens.xs || isScallingVersion;
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [hidePassword, setHidePassword] = useState(true);
  const [errInput, setErrInput] = useState(false);
  const [err, setErr] = useState("");
  const [errInputOld, setErrInputOld] = useState(false);
  const [errOld, setErrOld] = useState("");
  const [oldPassword, setOldPassword] = useState("");

  const resetState = () => {
    setOldPassword("")
    setPassword("");
    setConfirmPassword("");
    setHidePassword(true);
    setErr("");
    setErrOld("");
    setErrInput(false);
    setErrInputOld(false);
  };

  useEffect(() => {
    setErr("");
    setErrOld("");
    setErrInput(false);
    setErrInputOld(false)
  }, [password, confirmPassword, oldPassword]);

  useEffect(() => {
    resetState();
  }, [openModalPassword]);

  const handleSubmit = async () => {
    const messageAlert = (
      <>
        {t("feature.home.pop_up_change_password.password_doesnt_match")}
        <br />
        {t("feature.home.pop_up_change_password.please_review")}
      </>
    );
    
    if (
      // password == confirmPassword &&
      password != "" &&
      confirmPassword != "" &&
      oldPassword != ""
    ) {
      const payload = {
        password: password,
        password_confirmation: confirmPassword,
        change_password_type: "new",
        password_current: oldPassword
      };

      try {
        const { status, data } = await changePassword(
          { data: payload },
          getAccessToken(),
          i18n.language
        );
        dispatch(setInvalidToken(status));
        if (status == 200) {
          setPassword("");
          setConfirmPassword("");
          setHidePassword(true);

          setModalSuccessPassword(true);
          setModalPassword(false);
        } else {
          setErr(data[0]);
          setErrInput(true);
        }
      } catch (errData) {
        const data = errData.data;

        if(data.password !== undefined && data.password.length > 0) {
          const pass = data.password[0]
          const fixedText = pass.replace(/\\n/g, '\n');
          setErr(fixedText);
          setErrInput(true);
        } 
        if(data.password_current !== undefined && data.password_current.length > 0){
          setErrOld(data.password_current[0]);
          setErrInputOld(true);
        }
      }
    } else {
      setErrOld(t("feature.home.pop_up_change_password.all_fields_required"));
      setErrInputOld(true);
      setErrInput(true);
    }
  };

  const handlerCancel = () => {
    setModalPassword(!openModalPassword);
  };

  const isHTMLString = (str) => {
    if (typeof str !== "string") return false;

    const parser = new DOMParser();
    const doc = parser.parseFromString(str, "text/html");

    // cek apakah ada element HTML (bukan hanya text node)
    return Array.from(doc.body.childNodes).some(
      (node) => node.nodeType === 1
    );
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            borderRadius: "8px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
      <Modal
        className={
          isMobileVersion
            ? "modal-change-password-mobile"
            : "modal-change-password"
        }
        open={openModalPassword}
        maskClosable="false"
        closeIcon={null}
        transitionName="ant-fade"
        width={432}
        style={{ maxWidth: isMobileVersion ? "90%" : "432px" }}
        centered
        footer={null}
      >
        <div style={{ padding: isMobileVersion ? "20px" : "32px" }}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <p
              style={{
                color: isMobileVersion
                  ? colorTextTitleMobile
                  : textTitleChangePassword,
                fontWeight: "500",
                fontSize: isMobileVersion ? "16px" : "22px",
                marginBottom: isMobileVersion ? "0px" : "10px",
              }}
            >
              {t("feature.home.pop_up_change_password.change_password")}
            </p>
            <p
              style={{
                color: isMobileVersion
                  ? colorTextDesc
                  : textDescriptionChangePassword,
                fontSize: "14px",
                fontWeight: "400",
                margin: 0,
              }}
            >
              {t(
                "feature.home.pop_up_change_password.please_create_new_password",
              )}
            </p>
          </div>

          <Form onFinish={handleSubmit}>

            {/* alert old password */}
            {errOld && (
              <Alert
                message={errOld}
                type="error"
                className="alert-custom text-center"
                style={{
                  marginBottom: "20px",
                  borderRadius: isMobileVersion ? "6px" : "4px",
                }}
              />
            )}

            <div
              className="d-flex"
              style={{
                position: "relative",
                marginBottom: isMobileVersion ? "16px" : "20px",
              }}
            >
              <Input
                type={hidePassword ? "password" : "false"}
                className="form-control d-flex"
                style={{
                  borderRadius: "8px",
                  color: isMobileVersion
                    ? colorTextTitleMobile
                    : textInputChangePassword,
                  border: "1px solid",
                  borderColor: errInputOld
                    ? borderErrorInputChangePassword
                    : borderInputChangePassword,
                  height: "40px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
                id="id-old-password-change-password"
                placeholder={t("feature.home.pop_up_change_password.old_password")}
                onChange={(e) => setOldPassword(e.target.value)}
                value={oldPassword}
              />
              <div
                name="btn-hide-old-password-login"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: "5%",
                }}
                onClick={() => setHidePassword(!hidePassword)}
              >
                {hidePassword ? (
                  <Image
                    src={PasswordShow}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                ) : (
                  <Image
                    src={PasswordHide}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                )}
              </div>
            </div>

            {/* alert new password */}
            {err && (
              <Alert
                message={
                  <div className={isHTMLString(err) ? "alert-new-password" : ""}
                    dangerouslySetInnerHTML={{ __html: err }}
                  />
                }
                type="error"
                className="alert-custom text-center alert-change-password"
                style={{
                  marginBottom: "20px",
                  borderRadius: isMobileVersion ? "6px" : "4px"
                }}
              />
            )}

            <div
              className="d-flex"
              style={{
                position: "relative",
                marginBottom: isMobileVersion ? "16px" : "20px",
              }}
            >
              <Input
                type={hidePassword ? "password" : "false"}
                className="form-control d-flex"
                style={{
                  borderRadius: "8px",
                  color: isMobileVersion
                    ? colorTextTitleMobile
                    : textInputChangePassword,
                  border: "1px solid",
                  borderColor: errInput
                    ? borderErrorInputChangePassword
                    : borderInputChangePassword,
                  height: "40px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
                id="id-new-password-change-password"
                placeholder={t(
                  "feature.home.pop_up_change_password.new_password",
                )}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
              <div
                name="btn-hide-password-login"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: "5%",
                }}
                onClick={() => setHidePassword(!hidePassword)}
              >
                {hidePassword ? (
                  <Image
                    src={PasswordShow}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                ) : (
                  <Image
                    src={PasswordHide}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                )}
              </div>
            </div>
            <div className="d-flex" style={{ position: "relative" }}>
              <Input
                type={hidePassword ? "password" : "false"}
                className="form-control d-flex"
                style={{
                  borderRadius: "8px",
                  color: isMobileVersion
                    ? colorTextTitleMobile
                    : textInputChangePassword,
                  border: "1px solid",
                  borderColor: errInput
                    ? borderErrorInputChangePassword
                    : borderInputChangePassword,
                  height: "40px",
                }}
                id="id-confirm-new-password-change-password"
                placeholder={t(
                  "feature.home.pop_up_change_password.confirm_new_password",
                )}
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
              />
              <div
                name="btn-hide-change-password"
                style={{
                  cursor: "pointer",
                  position: "absolute",
                  top: 0,
                  bottom: 0,
                  right: "5%",
                }}
                onClick={() => setHidePassword(!hidePassword)}
              >
                {hidePassword ? (
                  <Image
                    src={PasswordShow}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                ) : (
                  <Image
                    src={PasswordHide}
                    preview={false}
                    width={isMobileVersion ? 24 : 22}
                    height="100%"
                  />
                )}
              </div>
            </div>

            {isMobileVersion ? (
              <Row
                style={{
                  justifyContent: "space-between",
                  flexWrap: "nowrap",
                  gap: "4%",
                  marginTop: "24px",
                }}
              >
                <Button
                  key="cancel-change-password"
                  className="btn btn-sm btn-secondary"
                  style={{
                    width: "48%",
                    borderRadius: "6px",
                    border: "1px solid " + colorButtonLogOut,
                    fontWeight: "500",
                    fontSize: "14px",
                    height: "40px",
                  }}
                  name="btn-cancel-change-password"
                  onClick={handlerCancel}
                >
                  {t("feature.home.pop_up_change_password.cancel")}
                </Button>
                <Button
                  key="change-password"
                  className="btn btn-sm btn-primary"
                  style={{
                    width: "48%",
                    borderRadius: "6px",
                    fontWeight: "500",
                    height: "40px",
                    fontSize: "14px",
                  }}
                  name="btn-change-password"
                  htmlType="submit"
                >
                  {t("feature.home.pop_up_change_password.change_password")}
                </Button>
              </Row>
            ) : (
              <div>
                <Button
                  key="change-password"
                  className="btn btn-sm btn-primary btn-block"
                  style={{
                    borderRadius: "6px",
                    border: "none",
                    fontWeight: "500",
                    height: "48px",
                    marginTop: "32px",
                  }}
                  name="btn-change-password"
                  htmlType="submit"
                >
                  {t("feature.home.pop_up_change_password.change_password")}
                </Button>
                <div
                  className="btn-link box-shadow-0"
                  style={{
                    fontWeight: "500",
                    border: "none",
                    marginTop: "20px",
                    textAlign: "center",
                  }}
                  name="btn-cancel-change-password"
                  onClick={handlerCancel}
                >
                  {t("feature.home.pop_up_change_password.cancel")}
                </div>
              </div>
            )}
          </Form>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ChangePassword;
